(ns ui.view.card.counterparty-diligence-responder.event
  (:require
   [common.util :as cu]
   [frontend.controller.websocket.event :as ws]
   [potpuri.core :as p]
   [re-frame.core :as rf]
   [ui.view.card.counterparty-diligence-responder.model :as model]
   [ui.view.card.event :as common-event]))

(rf/reg-event-fx
 ::open-send-to-responder-modal
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [card-state-path]}]]
   {:db (-> db
            (assoc-in (model/send-to-responder-modal-open-full-path card-state-path) true))}))

(rf/reg-event-fx
 ::close-send-to-responder-modal
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [card-state-path] :as _ctx}]]
   {:db (-> db
            (p/dissoc-in (model/send-to-responder-modal-open-full-path card-state-path)))}))

(rf/reg-event-db
 ::set-email-subject-line
 [rf/trim-v]
 (fn [db [{:keys [card-state-path] :as _ctx} value]]
   (assoc-in db (model/email-subject-line-full-path card-state-path) value)))

(rf/reg-event-db
 ::set-email-body
 [rf/trim-v]
 (fn [db [{:keys [card-state-path] :as _ctx} value]]
   (assoc-in db (model/email-body-full-path card-state-path) value)))

(rf/reg-event-db
 ::add-company-to-check
 [rf/trim-v]
 (fn [db [{:keys [card-state-path] :as _ctx}]]
   (update-in db (model/companies-to-check-full-path card-state-path) (fnil conj []) {})))

(rf/reg-event-db
 ::add-person-to-check
 [rf/trim-v]
 (fn [db [{:keys [card-state-path] :as _ctx}]]
   (update-in db (model/people-to-check-full-path card-state-path) (fnil conj []) {})))

(rf/reg-event-db
 ::set-row-data
 [rf/trim-v]
 (fn [db [{:keys [card-state-path] :as _ctx} {:keys [entity-type row-index row-data]}]]
   (let [path (case entity-type
                :company (conj (model/companies-to-check-full-path card-state-path) row-index)
                :person (conj (model/people-to-check-full-path card-state-path) row-index))]
     (assoc-in db path row-data))))

(rf/reg-event-db
 ::remove-entity-to-check
 [rf/trim-v]
 (fn [db [{:keys [card-state-path]} {:keys [row-index entity-type]}]]
   (let [path (case entity-type
                :company (model/companies-to-check-full-path card-state-path)
                :person (model/people-to-check-full-path card-state-path))

         prev-value (get-in db path)
         new-value (cu/vec-remove row-index prev-value)]
     (assoc-in db path new-value))))

(rf/reg-event-fx
 ::submit-callback
 [rf/trim-v]
 (fn [{:keys [_db]} [_ctx resp]]
   (js/console.log "Submit cb " resp)))

(rf/reg-event-fx
 ::send-to-responder
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [entity-id card-state-path] :as ctx}]]
   (let [email-subject-line (get-in db (model/email-subject-line-full-path card-state-path))
         email-body (get-in db (model/email-body-full-path card-state-path))
         companies-to-check (get-in db (model/companies-to-check-full-path card-state-path) [])
         people-to-check (get-in db (model/people-to-check-full-path card-state-path) [])]
     {::ws/send {:id         :counterparty-diligence/send-to-responder
                 :body       {:counterparty-diligence-id entity-id
                              :email-subject-line        email-subject-line
                              :email-body                email-body
                              :companies-to-check        companies-to-check
                              :people-to-check           people-to-check}
                 :on-success [::submit-callback ctx]
                 :on-error   [::submit-callback ctx]}})))

(rf/reg-event-fx
 ::update-responder-success
 [rf/trim-v]
 (fn [{:keys [_db]} [ctx resp]]
   (js/console.log "Update resp success " resp)
   {:fx [[:dispatch (common-event/create-fetch-card-data-event (assoc ctx :reset-entities? true))]]}))

(rf/reg-event-fx
 ::update-responder-error
 [rf/trim-v]
 (fn [{:keys [_db]} [_ctx resp]]
   (js/console.log "Update responder error " resp)))

(rf/reg-event-fx
 ::update-responder
 [rf/trim-v]
 (fn [{:keys [_db]} [{:keys [entity-id] :as ctx} {:keys [value]}]]
   {::ws/send {:id         :entity/update-attribute
               :body       {:db/id     entity-id
                            :attribute :counterparty-diligence/responder
                            :value     (if value
                                         #{value}
                                         #{})}
               :on-success [::update-responder-success ctx]
               :on-error   [::update-responder-error ctx]}}))
